import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-ops-settings-confirm-dialog',
    templateUrl: './ops-settings-confirm-dialog.component.html',
    styleUrls: ['./ops-settings-confirm-dialog.component.scss'],
    standalone: false,
})
export class OpsSettingsConfirmDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title?: string;
            description: string;
            cancelText?: string;
            confirmText?: string;
            isDelete?: boolean;
        },
        private dialogRef: MatDialogRef<OpsSettingsConfirmDialogComponent>
    ) {}

    cancel() {
        this.dialogRef.close(false);
    }

    confirm() {
        this.dialogRef.close(true);
    }
}
